import { compose, pure, setDisplayName, withProps, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import RefsStore from '../../../utils/refStorage';
import Search from '../../views/SearchModal';
import {
  selectQuery,
  selectResults,
  selectTotal,
  selectSize,
  selectPage,
  selectAllTotal,
  selectCategory
} from '../../../selectors';
import { enterSearch, searchByType, searchChangePage } from '../../../actions';
import {
  Documents,
  Folder,
  Group,
  UsuarioTransparente
} from '../../../../assets/images';

export default compose(
  setDisplayName('SearchContainer'),
  connect(
    createSelector(
      selectQuery(),
      selectResults(),
      selectTotal(),
      selectSize(),
      selectPage(),
      selectAllTotal(),
      selectCategory(),
      (query, results, total, size, page, getTotals, category) => ({
        query,
        results,
        total,
        size,
        page,
        getTotals,
        category
      })
    ),
    {
      enterSearch,
      searchChangePage,
      searchByType
    }
  ),
  withProps(({ getTotals }) => ({
    refs: RefsStore,
    tabs: [
      {
        name: 'Todo',
        type: 'all',
        size: getTotals.all
      },
      {
        name: 'Personas',
        type: 'users',
        icon: UsuarioTransparente,
        size: getTotals.users
      },
      {
        name: 'Contenidos',
        type: 'contents',
        icon: Documents,
        size: getTotals.contents
      },
      {
        name: 'Documentos',
        type: 'documents',
        icon: Folder,
        size: getTotals.documents
      },
      {
        name: 'Carpetas',
        type: 'folders',
        icon: Folder,
        size: getTotals.folders
      },
      {
        name: 'Áreas',
        type: 'associations',
        icon: Group,
        size: getTotals.associations
      }
    ]
  })),
  lifecycle({
    componentDidMount() {
      this.props.refs.get('inputSearch').value = '';
      this.props.refs.get('inputSearch').value = this.props.query;
      this.props.refs.get('inputSearch').focus();
    }
  }),
  pure
)(Search);
